import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";

import NextSearch from "components/Next/NextSearch";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getDatasetId = (props) => (props && props.datasetId ? props.datasetId : "new");

class NextSearchContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <NextSearch {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    updateSearchInsights: (field, filter, filterField, type) =>
      dispatch(nextReducer.updateSearchInsights(id, field, filter, filterField, type)),
    handleSearchInsights:
      ownProps.overrideSearch !== undefined
        ? ownProps.overrideSearch
        : (options, isDashboard) => {
            dispatch(nextReducer.handleSearchInsights(id, options, isDashboard));
          },
    updateSearchType: (type) => dispatch(nextReducer.updateSearchType(id, type)),
    updateIsHideSearch: (isHideSearch) => dispatch(nextReducer.updateIsHideSearch(id, isHideSearch)),
    updateIsHideLegend: (isHideLegend) => dispatch(nextReducer.updateIsHideLegend(id, isHideLegend)),
    updateIsAngleAxis: (isAngleAxis) => dispatch(nextReducer.updateIsAngleAxis(id, isAngleAxis)),
    updateDashboardSize: (dashboardSize) => dispatch(nextReducer.updateDashboardSize(id, dashboardSize)),
    updateRefreshRate: (refreshRate) => dispatch(nextReducer.updateRefreshRate(id, refreshRate)),
    updateIsDomainMin: (isDomainMin) => dispatch(nextReducer.updateIsDomainMin(id, isDomainMin)),
    assignTodo: (todo) => dispatch(nextModelsReducer.assignTodo(id, todo)),

    updateSearchNLQ: (NLQ) => dispatch(nextReducer.updateSearchNLQ(id, NLQ)),
    updateHoverGroup: (hoverGroup) => dispatch(nextReducer.updateHoverGroup(id, hoverGroup)),
    updateDatasetSuccess: (success) => dispatch(nextReducer.updateDatasetSuccess(id, success)),
    updateDashboardLayout: (dashboardLayout) => dispatch(nextReducer.updateDashboardLayout(id, dashboardLayout)),
    updateComparisonDashboardSortOrder: (val) => dispatch(nextReducer.updateComparisonDashboardSortOrder(id, val)),
    updateIsShowAllDashboard: (isShowAllDashboard) =>
      dispatch(nextReducer.updateIsShowAllDashboard(id, isShowAllDashboard)),

    initNextDashboard: (originalId, datasetId) => dispatch(nextReducer.initNextDashboard(originalId, datasetId)),

    exportToLooker: () => dispatch(nextReducer.exportToLooker(id)),

    updateIsGoogleAuthed: (isGoogleAuthed) => dispatch(globalReducer.updateIsGoogleAuthed(isGoogleAuthed)),

    updateShowHiddenCharts: (val) => dispatch(nextReducer.updateShowHiddenCharts(id, val)),

    openExploration: (datasetId, outcomeValue, comparisonOptions) =>
      dispatch(nextReducer.openExploration(datasetId, outcomeValue, comparisonOptions)),
    updateIgnoreInfoChartField: (ignoreInfoChartField) =>
      dispatch(nextReducer.updateIgnoreInfoChartField(id, ignoreInfoChartField)),
    createDashboard: () => dispatch(nextReducer.createDashboard(id)),
    updateMinimumValueCount: (val) => dispatch(nextReducer.updateMinimumValueCount(id, val)),
    updateComparisonOptions: (nextId, data) => dispatch(nextReducer.updateComparisonOptions(nextId, data)),
    updateComparisonChartOptions: (chartOptions) =>
      dispatch(nextReducer.updateComparisonChartOptions(id, chartOptions)),
    updateHideMissingInCharts: (hideMissingInCharts) =>
      dispatch(chatGPTReducer.updateHideMissingInCharts(hideMissingInCharts)),
    updateHideOtherInCharts: (hideOtherInCharts) => dispatch(chatGPTReducer.updateHideOtherInCharts(hideOtherInCharts)),
    updateDashboardSubchartsCount: (dashboardSubchartsCount) =>
      dispatch(nextReducer.updateDashboardSubchartsCount(id, dashboardSubchartsCount))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = ownProps.datasetId === undefined ? nextReducer.getDatasetId(state, id) : getDatasetId(ownProps);

  return {
    id: id,
    datasetId: datasetId,
    dataset: homeReducer.getDataset(state, datasetId),
    rankedFields: homeReducer.getRankedFields(state, datasetId),
    comparisonChartsByColumn: nextReducer.getComparisonChartsByColumn(state, id),

    hexSize: nextReducer.getHexSize(state, id),
    innerHexSize: nextReducer.getInnerHexSize(state, id),
    hexagonRadius: nextReducer.getHexagonRadius(state, id),

    insights: nextReducer.getSearchInsights(state, id),
    searchOpts: ownProps.searchOpts ? ownProps.searchOpts : nextReducer.getSearchOptions(state, id),

    searchType: nextReducer.getSearchType(state, id),
    searchInsights: nextReducer.getSearchInsights(state, id),

    isHideSearch: nextReducer.getIsHideSearch(state, id),
    isHideLegend: nextReducer.getIsHideLegend(state, id),
    isAngleAxis: nextReducer.getIsAngleAxis(state, id),

    datasetSuccess: nextReducer.getDatasetSuccess(state, id),
    successOptions: homeReducer.getSuccessOptions(state, datasetId),

    isDomainMin: nextReducer.getIsDomainMin(state, id),

    dashboardSize: nextReducer.getDashboardSize(state, id),
    refreshRate: nextReducer.getRefreshRate(state, id),

    isReplay: nextReducer.getIsReplay(state, id),
    comparisonOptions: nextReducer.getComparisonOptions(state, id),
    comparisonChartOptions: nextReducer.getComparisonChartOptions(state, id),

    hasModelDrivers: nextReducer.getHasModelDrivers(state, id),

    allCharts: nextReducer.getAllDashboardCharts(state, id, true),
    isShowAllDashboard: nextReducer.getIsShowAllDashboard(state, id),

    tempDatasetId: nextReducer.getTempDatasetId(state, id),
    dashboardLayout: nextReducer.getDashboardLayout(state, id),
    comparisonDashboardSort: nextReducer.getComparisonDashBoardSort(state, id),
    comparisonDashboardSortOrder: nextReducer.getComparisonDashBoardSortOrder(state, id),

    comparisonDashBoardSortOptions: nextReducer.getComparisonDashBoardSortOptions(state, id),
    comparisonDashboardSortOrderOptions: nextReducer.getComparisonDashboardSortOrderOptions(state, id),

    nextDatasets: homeReducer.getSimilarDatasets(state, datasetId),

    isExportingLooker: nextReducer.getIsExportingLooker(state, id),

    isGoogleMode: ownProps.isGoogleMode !== undefined ? ownProps.isGoogleMode : globalReducer.getIsGoogleMode(state),

    isGoogleAuthed: globalReducer.getIsGoogleAuthed(state),

    showHiddenCharts: nextReducer.getShowHiddenCharts(state, id),

    pinnedHexList: nextReducer.getPinnedHexListWithData(state, id),

    activeTab: nextReducer.getActiveTab(state, id),
    minimumValueCount: nextReducer.getMinimumValueCount(state, id),

    lookerSDK: loginReducer.getLookerAPIClient(state),
    linkedComparisonProjects: nextReducer.getLinkedComparisonProjects(state, nextReducer.getCurrentNextId(state)),
    nextId: nextReducer.getCurrentNextId(state),

    hideMissingInCharts: chatGPTReducer.getHideMissingInCharts(state, id),
    hideOtherInCharts: chatGPTReducer.getHideOtherInCharts(state, id),

    dashboardSubchartsCount: nextReducer.getDashboardSubchartsCount(state, id),

    getInsightFromMetadata: (metadata, metadataOnly = true) =>
      nextReducer.getInsightFromMetadata(state, id, metadata, metadataOnly)
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(NextSearchContainer);
